export default __webpack_public_path__ + "f0c670b.png";